import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EfImg from 'elem/ui/ef-img';

const { EFPic } = createEFPic('/img/landingPage/product/');

export default function M(): JSX.Element {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();
    const productListMap: any = {
        us: [
            {
                name: t('secM_product1'),
                img: ['Smart_Generator.webp', 'Smart_Generator.png'],
                link: 'https://www.ecoflow.com/us/dual-fuel-smart-generator',
            },
            {
                name: t('secM_product2'),
                img: ['400W_Solar_Panels.webp', '400W_Solar_Panels.png'],
                link: 'https://us.ecoflow.com/products/400w-portable-solar-panel?variant=39998021697609',
            },
            {
                name: t('secM_product3'),
                img: ['DELTA_Pro_Extra_Battery.webp', 'DELTA_Pro_Extra_Battery.png'],
                link: 'https://us.ecoflow.com/products/delta-pro-smart-extra-battery',
            },
        ],
        ca: [
            {
                name: t('secM_product4'),
                img: ['DPU_EB.png'],
                link: 'https://ca.ecoflow.com/products/delta-pro-ultra-battery',
            },
            {
                name: 'EcoFlow DELTA Pro 3 Smart Extra Battery',
                img: 'https://websiteoss.ecoflow.com/upload/image/1723024070687/sl_DP3EB.png',
                link: 'https://ca.ecoflow.com/products/delta-pro-3-extra-battery?variant=44902577209498',
            },
            {
                name: t('secM_product1'),
                img: ['Smart_Generator.webp', 'Smart_Generator.png'],
                link: '/dual-fuel-smart-generator',
            },
            {
                name: t('secM_product2'),
                img: ['400W_Solar_Panels.webp', '400W_Solar_Panels.png'],
                link: 'https://ca.ecoflow.com/products/400w-portable-solar-panel?variant=42092770263194',
            },
            // {
            //     name: t('secM_product3'),
            //     img: ['DELTA_Pro_Extra_Battery.webp', 'DELTA_Pro_Extra_Battery.png'],
            //     link: 'https://ca.ecoflow.com/products/delta-pro-smart-extra-battery',
            // },
        ],
        sa: [
            // {
            //     name: t('m_product1'),
            //     img: ['delta2_EB.webp', 'delta2_EB.png'],
            //     link: '',
            // },
            {
                name: t('m_product2'),
                img: ['DELTA_Pro_Extra_Battery.webp', 'DELTA_Pro_Extra_Battery.png'],
                link: 'https://www.amazon.ae/dp/B0B45XT3RW?ref=myi_title_dp',
            },
            {
                name: t('m_product3'),
                img: ['river_pro_eb.webp', 'river_pro_eb.png'],
                link: 'https://www.amazon.ae/dp/B0B31FLNV7?ref=myi_title_dp',
            },
            // {
            //     name: t('m_product4'),
            //     img: ['400w_rigid.webp', '400w_rigid.png'],
            //     link: '',
            // },
            // {
            //     name: t('m_product5'),
            //     img: ['100w_rigid.webp', '100w_rigid.png'],
            //     link: '',
            // },
            {
                name: t('m_product6'),
                img: ['400W_Solar_Panels.webp', '400W_Solar_Panels.png'],
                link: 'https://www.amazon.ae/dp/B0B4627CBJ?ref=myi_title_dp',
            },
        ],
        za: [
            {
                name: t('m_product1'),
                img: ['delta2_EB.webp', 'delta2_EB.png'],
                link: 'https://za.ecoflow.com/products/delta-2-smart-extra-battery',
            },
            {
                name: t('m_product2'),
                img: ['DELTA_Pro_Extra_Battery.webp', 'DELTA_Pro_Extra_Battery.png'],
                link: 'https://za.ecoflow.com/products/delta-pro-smart-extra-battery',
            },
            {
                name: t('m_product3'),
                img: ['river_pro_eb.webp', 'river_pro_eb.png'],
                link: 'https://za.ecoflow.com/products/river-pro-extra-battery',
            },
            {
                name: t('m_product4'),
                img: ['400w_rigid.webp', '400w_rigid.png'],
                link: 'https://za.ecoflow.com/products/400w-rigid-solar-panel',
            },
            {
                name: t('m_product5'),
                img: ['100w_rigid.webp', '100w_rigid.png'],
                link: 'https://za.ecoflow.com/products/100w-rigid-solar-panel',
            },
            {
                name: t('m_product6'),
                img: ['400W_Solar_Panels.webp', '400W_Solar_Panels.png'],
                link: 'https://za.ecoflow.com/products/400w-solar-panel',
            },
        ],
        au: [
            {
                name: t('m_product1'),
                img: ['delta2_EB.webp', 'delta2_EB.png'],
                link: 'https://au.ecoflow.com/products/delta-2-smart-extra-battery',
            },
            {
                name: t('m_product2'),
                img: ['DELTA_Pro_Extra_Battery.webp', 'DELTA_Pro_Extra_Battery.png'],
                link: 'https://au.ecoflow.com/products/delta-pro-smart-extra-battery',
            },
            {
                name: t('m_product3'),
                img: ['river_pro_eb.webp', 'river_pro_eb.png'],
                link: 'https://au.ecoflow.com/products/river-pro-extra-battery',
            },
            {
                name: t('m_product4'),
                img: ['400w_rigid.webp', '400w_rigid.png'],
                link: 'https://au.ecoflow.com/products/400w-rigid-solar-panel',
            },
            {
                name: t('m_product5'),
                img: ['100w_rigid.webp', '100w_rigid.png'],
                link: 'https://au.ecoflow.com/products/100w-rigid-solar-panel',
            },
            {
                name: t('m_product6'),
                img: ['400W_Solar_Panels.webp', '400W_Solar_Panels.png'],
                link: 'https://au.ecoflow.com/products/400w-portable-solar-panel',
            },
        ],
    };
    const productList = productListMap[locale] || productListMap.us;

    return (
        <div className={`landing_page_M ${css.landing_page_M}`}>
            <div className="viewport-wrapper">
                {productList.map((product: any, index: number) => (
                    <div className="product" key={index}>
                        {String(product?.img)?.startsWith('https://') ? (
                            <EfImg className="product-img" pc={product.img} />
                        ) : (
                            <EFPic name={product.img} className="product-img" />
                        )}
                        <div className="name">{product.name}</div>
                        <Link
                            className="buy-btn"
                            href={product?.link}
                            target="blank"
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: product?.name.replaceAll('\n', ' '),
                                position: `Solution Page_${t('secE_item3_title_1')}`,
                            }}
                        >
                            {t('learn_more')}
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
}
